import { useMediaQuery } from 'react-responsive';
import theme from "../../theme";
export default function useBreakpoints() {
  var isMobile = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints[0], ")")
  });
  var isTablet = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints[1], ")")
  });
  var isDesktop = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints[2], ")")
  });
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop
  };
}